<script>
import { mapGetters } from 'vuex'

export default {
  props: {
    ratePlan: { type: Object, required: true },
    room: { type: Object, required: true },
  },
  computed: {
    ...mapGetters('auth', ['loggedIn']),
    ...mapGetters('cart', ['los']),
    displayRate() {
      const { promotion, member } = this.ratePlan.rate
      if (!this.loggedIn) {
        return promotion.display
      }

      return member.display
    },
  },
  methods: {
    goToLoginPage() {
      this.$router.push({
        name: 'member-login',
        params: {
          property: this.$route.params.property
        },
        query: {
          redirectFrom: this.$route.fullPath,
        },
      })
    }
  }
}
</script>

<template>
  <div>
    <!-- <div v-if="ratePlan.savingPercentage" class="mt-3">
      <div
        class="inline-block bg-red-600 px-1 font-medium text-white text-sm uppercase"
      >
        save {{ ratePlan.savingPercentage }}% today!
      </div>
    </div> -->
    <div class="px-3">
      <div class="my-3 text-right">
        <div
          v-if="ratePlan.rate.promotion.display < ratePlan.rate.rack.display"
          class="inline-block relative crossed-out"
        >
          <span class="mr-1">
            {{ ratePlan.rate.promotion.currency }}
          </span>
          <span class="text-lg">
            {{ ratePlan.rate.rack.display | currency }}
          </span>
        </div>
        <div class="leading-none">
          <div class="text-red-500 mb-1">
            <span class="text-xl mr-1">
              {{ ratePlan.rate.promotion.currency }}
            </span>
            <span class="font-medium text-2xl md:text-3xl">
              {{ displayRate | currency }}
            </span>
          </div>
          <div v-if="!loggedIn" class="inline-block bg-gray-300 p-2 rounded cursor-pointer" @click="goToLoginPage">
            <span class="block text-sm text-center">Member Price</span>
            <div>
              <span class="text-xl mr-1">
                <BaseIcon class="text-sm mr-2" name="lock" />
                {{ ratePlan.rate.member.currency }}
              </span>
              <span class="text-xl md:text-2xl text-right">
                {{ ratePlan.rate.member.display | currency }}
              </span>
            </div>
            <div></div>
          </div>
          <div class="text-sm leading-tight">
            Price for {{ los | pluralize('night') }}</div
          >
          <div class="text-sm italic leading-tight">
            {{
              ratePlan.rate.promotion.inclusiveFees ? 'Inclusive' : 'Exclusive'
            }}
            tax and service
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- price column -->
</template>
